<template>
  <div>
    <el-col :span="6" v-for="item in result.data" :key="item.artiId" class="yi-cun-section-wrap">
      <el-button
        @click="open(item)"
        class="yi-cun-section"
        target="_blank"
        style="background-color:#f5e8d3;"
      >
        <div>
          <img
            :src="item.imgUrl||$app.nodata.img"
            style="width:160.5px;height:113.95px;"
            class="img-fluid"
          />
          <h5 class="title" v-text="item.artiName"></h5>
        </div>
      </el-button>
      <div class="bottom">&nbsp;</div>
    </el-col>
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      :modal-append-to-body="true"
      :append-to-body="true"
      :lock-scroll="true"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
      custom-class="portal-arti-page-whyc-dialog"
      center
    >
      <iframe
        name="iframe-popup"
        frameborder="0"
        style="width: 100%; height: 100%"
        border="0"
        v-bind:src="popupUrl"
      ></iframe>
      <!-- <img v-show="item.fileUrl" style="width: 100%; height: 100%" src="../../assets/portal/zwsj.png" > -->
    </el-dialog>
  </div>
</template>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      routeType: "arti",
      popupUrl: "",
      dialogVisible: false
    };
  },
  mounted() {},
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object
    }
  },
  components: {},
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/portal/arti/detail/${_module}/${_field}_detail/${item.artiId}`
      });
    },
    open(item) {
      if (item.fileUrl != null && item.fileUrl != "") {
        this.popupUrl = item.fileUrl;
        this.dialogVisible = true;
      } else {
        this.$message("暂无数据");
      }
    },
  },
  created() {
    //this.$menuFn.setTitle("portal-from-detail");
  },
  watch: {}
};
</script>
<style lange="sass" scoped>
</style>